(function () {
'use strict';

angular.module('hyresgastApp').controller('ListNegotiationAllCtrl', ListNegotiationAllCtrl);

function ListNegotiationAllCtrl(
  $location, $filter, $timeout, $document,
  Auth,
  Parties, CombinedNegotiationStates, Regions, NegotiationTypes, Limits, CommonIds,
  Negotiation
) {
  var vm = this;

  vm.statusChoices = Object.values(CombinedNegotiationStates).map(x => ({
    id: x,
    text: $filter('hyCombinedNegotiationStates')(x)
  }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));
  vm.regionChoices = Object.values(Regions).map(r => ({
    id: r,
    text: $filter('regionTypeToDescription')(r)
  }));
  vm.regionChoices.unshift({ id: CommonIds.tableauAllId, text: 'Alla regioner' });
  vm.regionFilter = vm.regionChoices[0];
  vm.gotoNegotiation = gotoNegotiation;
  vm.pageLimit = 30;

  Auth.heartbeat().then(function() {
    if (Auth.currentUser().party === Parties.HGF) {
      vm.isHgfUser = true;
      vm.tableColumns = [
        {
          title: 'Id',
          column: 'caseNumber'
        },
        {
          title: 'Namn',
          column: 'name'
        },
        {
          title: 'Organisation',
          column: 'counterpart.name'
        },
        {
          title: 'Förhandlingstyp',
          template: 'slot1',
          column: 'type',
          lookup: {
            idProperty: 'id',
            textProperty: 'text',
            dictionary: vm.negotiationTypeChoices,
            multi: true,
          },
        },
        {
          title: 'Status',
          template: 'status',
          column: 'combinedState',
          lookup: {
            idProperty: 'id',
            textProperty: 'text',
            dictionary: vm.statusChoices,
            multi: true,
          },
        },
        {
          title: 'Begärt ändringsdatum',
          column: 'rentEffectiveFrom'
        },
        {
          title: 'Önskat datum för förhandling',
          column: 'callForNegotiation.negotiationDate'
        },
        {
          title: '',
          template: 'comment',
          filterType: 'none'
        }
      ];
    } else {
      vm.tableColumns = [
        {
          title: 'Id',
          column: 'caseNumber'
        },
        {
          title: 'Namn',
          column: 'name'
        },
        {
          title: 'Organisation',
          column: 'counterpart.name'
        },
        {
          title: 'Förhandlingstyp',
          column: 'type'
        },
        {
          title: 'Status',
          column: 'combinedState'
        },
        {
          title: 'Ansvarig hos oss',
          column: 'extNegotiator.firstname'
        },
        {
          title: 'Ansvarig HGF',
          column: 'hgfNegotiator.firstname'
        },
        {
          title: 'Önskat datum för förhandling',
          column: 'callForNegotiation.negotiationDate'
        }
      ];
    }
  });

  function gotoNegotiation(negotiation) {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  }

  let getTableau = () => angular.element($document[0].querySelector("#negotiationsAllTableau")).scope();

  let getParams = (includeProperties) => {
    let tableauParams = vm.lastParams;
    tableauParams.limit = Limits.InMemoryMiddleLimit;
    tableauParams.offset = 0;
    if (includeProperties) {
      tableauParams.includeProperties = includeProperties;
    }
    return tableauParams;
  };
  vm.getAllNegotiations = (cb, includeProperties) => {
    Negotiation.query(getParams(includeProperties), {})
      .$promise.then(function (data) { cb(data) });
  };

  vm.tableFGetData = params => {
    // eslint-disable-next-line no-undef
    return new Promise((resolve, reject) => {
      if (vm.regionFilter.id !== CommonIds.tableauAllId) {
        params['filters[office.regionId]'] = vm.regionFilter.id;
      }
      Negotiation.query(params)
        .$promise.then(result => resolve(result))
        .catch(err => reject(err));
    });
  };
  vm.changeRegion = () => {
    $timeout(() => { getTableau().$broadcast('refresh') }, 200);
  };
}

})();